import React, { useEffect, useState } from "react";
import { Button, SelectInput } from "@life-line-lab/components-react";
import { Col, Row } from "antd";
import { useTranslation } from "react-i18next";
import { isEmpty, omitBy, isNil } from "lodash";
import { QuestionCircleOutlined } from "@ant-design/icons";

const DownloadOrders = (props: any) => {
  const { t } = useTranslation();
  const { onFilter, onGenerate, versionList, isLoading } = props || {};

  //   Component Filters
  // ==========================================
  const initialFilters = {
    versionPayload: "v1.00",
    versionResult: "v1.00",
    deliveryTypePayload: "First-Mile + Mid-Mile",
    deliveryTypeResult: "First-Mile + Mid-Mile",
  };

  const [filterState, setFilterState] = useState<any>(initialFilters);

  useEffect(() => {
    if (onFilter && !isEmpty(filterState)) {
      const filterPayload = omitBy(filterState, (input) => isNil(input) || isEmpty(input));
      onFilter(filterPayload);
    }
  }, [filterState]);

  //   Select Options
  // ==========================================

  // delivery type options
  const deliveryOptions = [
    { label: t("option.FIRST_MILE_MID_MILE"), value: "First-Mile + Mid-Mile" },
    { label: t("option.MID_MILE_ONLY"), value: "Mid-Mile Only" },
    { label: t("option.MID_MILE_LAST_MILE"), value: "Mid-Mile + Last-Mile" },
    { label: t("option.END_TO_END"), value: "End To End" },
  ];

  const handleFilterChange = (value: any, name: string) => {
    setFilterState && setFilterState((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="om-po-container">
      <div className="om-po-section">
        <div className="om-po-title">{t("label.planScheduleResult")}</div>
        {isLoading && (
          <div className="om-info om-help">
            <QuestionCircleOutlined style={{ fontSize: "16px" }} />
            <div>{t("txt.planScheduleResultLoading")}</div>
          </div>
        )}
        <Row gutter={[16, 8]} align="bottom">
          <Col flex="1 1 0px">
            <SelectInput
              showSearch
              placeholder="Select option"
              label="Version"
              options={versionList}
              value={filterState?.versionResult}
              filterOption={(inputValue, option) =>
                option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
              }
              onChange={(value) => {
                handleFilterChange(value, "versionResult");
              }}
            />
          </Col>
          <Col flex="1 1 0px">
            <SelectInput
              showSearch
              placeholder="Select option"
              label="Delivery type"
              options={deliveryOptions}
              value={filterState?.deliveryTypeResult}
              filterOption={(inputValue, option) =>
                option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
              }
              onChange={(value) => {
                handleFilterChange(value, "deliveryTypeResult");
              }}
            />
          </Col>
          <Col flex="none">
            <Button
              isLoading={isLoading}
              label={t("action.generate")}
              onClick={() => onGenerate("result")}
              type="primary"
            />
          </Col>
        </Row>
      </div>
      <div className="dm-divider pad-24"></div>
      <div className="om-po-section">
        <div className="om-po-title">{t("label.planSchedulePayload")}</div>
        <Row gutter={[16, 8]} align="bottom">
          <Col flex="1 1 0px">
            <SelectInput
              showSearch
              placeholder="Select option"
              label="Version"
              options={versionList}
              value={filterState?.versionPayload}
              filterOption={(inputValue, option) =>
                option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
              }
              onChange={(value) => {
                handleFilterChange(value, "versionPayload");
              }}
            />
          </Col>
          <Col flex="1 1 0px">
            <SelectInput
              showSearch
              placeholder="Select option"
              label="Delivery type"
              options={deliveryOptions}
              value={filterState?.deliveryTypePayload}
              filterOption={(inputValue, option) =>
                option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
              }
              onChange={(value) => {
                handleFilterChange(value, "deliveryTypePayload");
              }}
            />
          </Col>
          <Col flex="none">
            <Button
              label={t("action.generate")}
              onClick={() => onGenerate("payload")}
              type="primary"
            />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default DownloadOrders;
